import React from 'react'
import { useTheme } from '@mui/material'
import { DataGrid, DataGridProps } from '@mui/x-data-grid'

const CardDataGrid: React.FC<DataGridProps> = props => {
  const theme: any = useTheme()
  return (
    <DataGrid
      {...props}
      hideFooterSelectedRowCount
      sx={{
        borderRadius: theme.components.MuiCard.styleOverrides.root.borderRadius,
        border: theme.components.MuiCard.styleOverrides.root.border,
        boxShadow: theme.shadows[1],
        ...props.sx,
      }}
    />
  )
}

export default CardDataGrid
